import { readContracts } from '@wagmi/core';

import { erc20Abi } from 'viem';

// eslint-disable-next-line deprecate/import
import { wagmiConfig } from '@shared/common/providers/LegacyWeb3Provider/wagmi';
import type { Web3Handle } from '@shared/helpers/web3/handle';

import type { TokenInfo } from './types';

export async function getTokenInfo(tokenHandle?: Web3Handle): Promise<TokenInfo | undefined> {
  if (!tokenHandle) {
    return;
  }

  const [decimals, name, symbol] = await readContracts(wagmiConfig, {
    allowFailure: false,
    contracts: [
      {
        address: tokenHandle.address,
        abi: erc20Abi,
        functionName: 'decimals',
        chainId: tokenHandle.chainId,
      },
      {
        address: tokenHandle.address,
        abi: erc20Abi,
        functionName: 'name',
        chainId: tokenHandle.chainId,
      },
      {
        address: tokenHandle.address,
        abi: erc20Abi,
        functionName: 'symbol',
        chainId: tokenHandle.chainId,
      },
    ],
  });

  return {
    address: tokenHandle.address,
    decimals,
    name,
    symbol,
  };
}
